import { render, staticRenderFns } from "./StudentPosterWooCommerce.vue?vue&type=template&id=457f7a79&scoped=true&"
import script from "./StudentPosterWooCommerce.vue?vue&type=script&lang=js&"
export * from "./StudentPosterWooCommerce.vue?vue&type=script&lang=js&"
import style0 from "./StudentPosterWooCommerce.vue?vue&type=style&index=0&id=457f7a79&lang=scss&scoped=true&"
import style1 from "./StudentPosterWooCommerce.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457f7a79",
  null
  
)

export default component.exports